/**
 * StarRating - Componente de Calificación con Estrellas
 * Muestra y permite dar ratings de 1 a 5 estrellas
 */
import { useState } from 'react';
import { Star } from 'lucide-react';

const StarRating = ({ 
  rating = 0, 
  maxRating = 5, 
  size = 'md',
  interactive = false,
  onRate = null,
  showCount = false,
  count = 0,
  className = ''
}) => {
  const [hoverRating, setHoverRating] = useState(0);
  
  const sizes = {
    xs: 'w-3 h-3',
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6'
  };
  
  const handleClick = (value) => {
    if (interactive && onRate) {
      onRate(value);
    }
  };
  
  const displayRating = hoverRating || rating;
  
  return (
    <div className={`flex items-center gap-1 ${className}`}>
      <div className="flex items-center">
        {[...Array(maxRating)].map((_, index) => {
          const starValue = index + 1;
          const isFilled = starValue <= displayRating;
          const isHalfFilled = !isFilled && starValue - 0.5 <= displayRating;
          
          return (
            <button
              key={index}
              type="button"
              disabled={!interactive}
              onClick={() => handleClick(starValue)}
              onMouseEnter={() => interactive && setHoverRating(starValue)}
              onMouseLeave={() => interactive && setHoverRating(0)}
              className={`${interactive ? 'cursor-pointer hover:scale-110' : 'cursor-default'} transition-transform focus:outline-none`}
            >
              <Star 
                className={`${sizes[size]} transition-colors ${
                  isFilled 
                    ? 'fill-amber-400 text-amber-400' 
                    : isHalfFilled 
                      ? 'fill-amber-400/50 text-amber-400' 
                      : 'text-zinc-600'
                }`}
              />
            </button>
          );
        })}
      </div>
      
      {showCount && (
        <span className="text-xs text-zinc-500 ml-1">
          ({count})
        </span>
      )}
      
      {rating > 0 && !showCount && (
        <span className="text-xs text-zinc-400 ml-1">
          {rating.toFixed(1)}
        </span>
      )}
    </div>
  );
};

export default StarRating;
